module.exports = __webpack_public_path__ + "img/yds.795784b6.jpg";